import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HouseMark } from './HouseMark.js';
export function Wordmark({ name = 'Atlas Nook', descriptor = 'studio', compact = false, href, }) {
    const classes = compact ? 'wordmark wordmark-compact' : 'wordmark';
    const inner = (_jsxs(_Fragment, { children: [_jsx(HouseMark, {}), _jsx("span", { className: "wm-name", children: name }), _jsx("span", { className: "wm-desc", children: descriptor })] }));
    if (href !== undefined) {
        return (_jsx("a", { className: classes, href: href, lang: "en", children: inner }));
    }
    return (_jsx("span", { className: classes, lang: "en", children: inner }));
}
//# sourceMappingURL=Wordmark.js.map